import { render, staticRenderFns } from "./BaseConfirmDialog.vue?vue&type=template&id=70f8b7aa&scoped=true&"
import script from "./BaseConfirmDialog.vue?vue&type=script&lang=js&"
export * from "./BaseConfirmDialog.vue?vue&type=script&lang=js&"
import style0 from "./BaseConfirmDialog.vue?vue&type=style&index=0&id=70f8b7aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f8b7aa",
  null
  
)

export default component.exports